<template>
  <div>
    <v-card>
      <v-card-title>
        <div class="card-header text-unset" style="width: 100%">
          <h5>
            <b>{{ $t("fp.deposit-history") }}</b>
          </h5>
        </div>
        <v-spacer></v-spacer>
      </v-card-title>
      <div style="width: 100%; padding-left: 20px">
        <input
          type="checkbox"
          :value="$t('fp.show-inactive')"
          v-model="showInactive"
        />
        <span style="padding-left: 5px; font-size: small; font-weight: bold">{{
          $t("fp.show-inactive")
        }}</span>
      </div>
      <div
        style="
          background-color: gainsboro;
          margin-top: 10px;
          padding-left: 20px;
          font-size: medium;
        "
      >
        {{ $t("fp.deposits-from-active-freedom-programs") }}
      </div>
      <v-data-table
        class="mb-3"
        dense
        :headers="headers"
        :items="modifyDepositsOutput()"
        item-key="id"
        hide-default-footer="true"
        disable-pagination="true"
      >
        <template v-slot:items="props">
          <td class="">
            <div v-if="props.item.rewardInstallment &gt; 0">
              <font-awesome-icon
                style="color: orange"
                v-if="props.item.rewardInstallment &gt; 0"
                :icon="['fas', 'star']"
              />
              <span
                style="color: orange"
                v-if="props.item.rewardInstallment &gt; 0"
                >{{ $t("fp.bonus") }}</span
              >
            </div>
            {{ props.item.programName }}
          </td>
          <td class="date-time-width">
            {{ props.item.id | formatDate }}
          </td>

          <td class="">{{ props.item.valueInTokens | formatHtl }} HTL</td>
          <td>{{ props.item.valueInFiat | formatEur }} EUR</td>
        </template>
      </v-data-table>
      <div
        v-if="this.showInactive === true"
        style="
          background-color: gainsboro;
          margin-top: 10px;
          padding-left: 20px;
          font-size: medium;
        "
      >
        {{ $t("fp.deposits-from-inactive-freedom-programs") }}
      </div>
      <v-data-table
        v-if="this.showInactive === true"
        class="mb-3"
        dense
        :headers="headers"
        :items="modifeOldDepositsOutput()"
        item-key="id"
        hide-default-footer="true"
        disable-pagination="true"
      >
        <template v-slot:items="props">
          <td class="">
            <div v-if="props.item.rewardInstallment &gt; 0">
              <font-awesome-icon
                style="color: orange"
                v-if="props.item.rewardInstallment &gt; 0"
                :icon="['fas', 'star']"
              />
              <span
                style="color: orange"
                v-if="props.item.rewardInstallment &gt; 0"
                >{{ $t("fp.bonus") }}</span
              >
            </div>
            {{ props.item.programName }}
          </td>
          <td class="date-time-width">
            {{ props.item.id | formatDate }}
          </td>
          <td class="">{{ props.item.valueInTokens | formatHtl }} HTL</td>
          <td>{{ props.item.valueInFiat | formatEur }} EUR</td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
  
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faStar } from "@fortawesome/free-solid-svg-icons";

library.add(faStar);
export default {
  name: "MyFreedomProgramHistory",
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      headers: [
        {
          value: "programName",
          text: this.$i18n.t("fp.fptable-program-name"),
          sortable: false,
        },
        {
          value: "id",
          text: this.$i18n.t("fp.fptable-payment-date"),
          sortable: false,
        },

        {
          value: "valueInTokens",
          text: this.$i18n.t("fp.fptable-value-htl"),
          sortable: false,
        },
        {
          value: "valueInFiat",
          text: this.$i18n.t("fp.fptable-value-eur"),
          sortable: false,
        },
      ],
      showInactive: false,
    };
  },
  props: ["freedomPrograms", "oldFreedomPrograms"],
  mounted() {},

  methods: {
    modifyDepositsOutput() {
      var deposits = [];
      this.freedomPrograms.forEach((fp, index) => {
        fp.deposits.forEach((dep) => {
          deposits.push({
            programName:
              this.$i18n.t("fp.fptable-program-name") + " " + (1 + index),
            id: dep.id,
            valueInTokens: dep.valueInTokens,
            valueInFiat: dep.valueInFiat,
            rewardInstallment: dep.rewardInstallment,
          });
        });
      });

      return deposits.sort((a, b) => (a.id > b.id ? 1 : -1));
    },
    modifeOldDepositsOutput() {
      var deposits = [];
      this.oldFreedomPrograms.forEach((fp, index) => {
        fp.deposits.forEach((dep) => {
          deposits.push({
            programName:
              this.$i18n.t("fp.fptable-program-name") + " " + (1 + index),
            id: dep.id,
            valueInTokens: dep.valueInTokens,
            valueInFiat: dep.valueInFiat,
            rewardInstallment: dep.rewardInstallment,
          });
        });
      });

      return deposits.sort((a, b) => (a.id > b.id ? 1 : -1));
    },
  },
};
</script>
  
<style scoped></style>